export const SUMMARY_REPORT_STATS_PROPERTIES = [
  'count',
  'min',
  'max',
  'average',
  'stdDev',
  'quartile0',
  'quartile1',
  'quartile2',
  'quartile3',
  'quartile4',
  'pp',
  'ppl',
  'ppu',
  'ppk',
];
